'use client';

import BusinessProductCard from '@/storyblok/businessProductCard/BusinessProductCard';
import BusinessProductCardsSlider from '@/storyblok/businessProductCards/BusinessProductCardsSlider';
import type { ComponentBusinessProductCardsStoryblok } from '@/types/component-types-sb';
import classNames from 'classnames';
import { Fragment } from 'react';

import classes from './BusinessProductCards.module.scss';

const BusinessProductCards: React.FC<{ blok: ComponentBusinessProductCardsStoryblok }> = ({ blok }) => {
  const cardCount = blok.product_cards?.length ?? 0;
  const hasMultipleCards = cardCount > 1;

  return (
    <div
      id={blok.anchor || undefined}
      className={classNames(
        classes.layouts,
        hasMultipleCards && classes.sliderOnMobile,
        hasMultipleCards && classes.sliderOnTablet
      )}
    >
      <div className={classNames(classes.businessProductCards, classes.gridLayout)}>
        {blok.product_cards?.map((product) => (
          <Fragment key={product._uid}>
            <BusinessProductCard
              blok={product}
              groupLink={blok.link}
              groupFormProductFieldName={blok.formProductFieldName}
            />
          </Fragment>
        ))}
      </div>
      {hasMultipleCards && (
        <div className={classes.sliderLayout}>
          <BusinessProductCardsSlider blok={blok} />
        </div>
      )}
    </div>
  );
};

export default BusinessProductCards;
